import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  animationItem: ".drawer-menu__contents, .drawer-menu__footer",
};

export default node => {
  if (!shouldAnimate(node)) return;
  delayOffset(node, [selectors.animationItem]);
};
